module.exports = __webpack_public_path__ + "img/e-tracker.3c3ee5d5.jpg";